
<template>
    <article class="checkout">
        <div class="center">
            <ul v-if="shoots.length">
                <li v-for="shoot in shoots">
                    <router-link :to="{ name: 'shoot', params: { id: shoot.shoot_id }}">
                        {{ shoot.title }}
                        {{ shoot.location }}
                    </router-link>
                </li>
            </ul>
            <form v-else v-on:submit.prevent="find">
                <label>
                    Photoshoot code:
                    <input type="text" v-model="id"/>
                    <p v-if="error" class="is-bold">Code not recognised</p>
                </label>
            </form>
        </div>
    </article>
</template>

<script>
    import auth from '../support/Auth';
    import Shoot from '../models/Shoot';

    export default
    {
        data()
        {
        	return {
        		id: undefined,
                error: false,
        		auth,
                shoots: [],
            };
        },
        methods:
        {
            find()
            {
            	this.checking = true;
            	this.error = false;
            	Shoot.fetch( this.id ).then( shoot => {
		            this.$router.push( { name: 'shoot', params: { id: this.id } } );
                    this.checking = false;
            	}, () => {
            		this.error = true;
            		this.checking = false;
                });
            },
        },
        mounted()
        {
        	if( this.auth.check && this.auth.user ) {
		        Shoot.all().then( shoots => {
			        if( shoots.length === 1 )
				        this.$router.push( { name: 'shoot', params: { id: shoots[0].shoot_id } } );

			        this.shoots = shoots
		        });
            }
        }
    }
</script>
